var React = require('react');

function PaperAirplane (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 5"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/blurb/post2","transform":"translate(0.000000, -1.000000)","stroke":"#5B00DB","strokeWidth":"2"},React.createElement("g",{"id":"Group-5","transform":"translate(1.476968, 2.229174)"},[React.createElement("polygon",{"id":"Stroke-1","points":"0 16.1397895 37.005848 0 30.8962807 31.8590877 15.1769825 22.1157427","key":0}),React.createElement("polyline",{"id":"Stroke-3","points":"37.005848 0.000261988304 15.1769825 22.1160047 15.1769825 35.5599345 21.7266901 26.1034667","key":1})])))]);
}

PaperAirplane.defaultProps = {"width":"40px","height":"38px","viewBox":"0 0 40 38","version":"1.1"};

module.exports = PaperAirplane;

PaperAirplane.default = PaperAirplane;
